<h1 mat-dialog-title>Return to Initiator</h1>
<div mat-dialog-content>
  <dynamic-grid
    class="grid-cell"
    *ngIf="loadGrid"
    [pageSize]="pageSize"
    [rows]="rows"
    [cols]="cols"
    [showSearch]="false"
    [isEditable]="true"
    [canAddRow]="false"
    [isRowSelectable]="true"
    [allowMultiRowSelection]="true"
    [showCheckboxForSelection]="true"
    (onRowSelection)="onRowSelection($event)"
  ></dynamic-grid>
</div>

<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-raised-button mat-dialog-close class="one">
      {{ "Return_to_Initiator.cancel" | translate }}
    </button>
    <button
      mat-button
      mat-raised-button
      cdkFocusInitial
      class="two"
      color="primary"
      (click)="onSend()"
      [disabled]="!isSelected"
    >
      {{ "Return_to_Initiator.send" | translate }}
    </button>
  </div>
</mat-dialog-actions>

<ng-template
  #initiatorTemplate
  let-col="col"
  let-row="row"
  let-renderValue="renderValue"
  let-value="value"
>
  <div class="d-inline-flex align-items-center">
    <div>
      <div class="row d-inline">
        <div
          class="col-md-12 d-inline"
          [class.is-initiator]="!row?.initiator?.empName"
          [class.is-header]="true"
        >
          {{ row?.initiator?.empName ? row?.initiator?.empName : message }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
